import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'exit';
export const route = 'exit';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "exit" */
/* webpackPrefetch: true */
'../components/ExitPage')));